import type {SkipToken} from '@reduxjs/toolkit/query'
import {skipToken} from '@reduxjs/toolkit/query'

import {useBranch, useBuildTypeId} from '../../../../hooks/routes'
import {getBranchLocator} from '../../../../rest/locators'
import type {GetAllBuildsApiArg} from '../../../../services/rest'
import {getBuildChainLocator} from '../../BuildPage/DependenciesTab/DependenciesTab.utils'

const commonBuildFields = 'id,status,state,canceledInfo,failedToStart'

export const useBuildTypeChainsArg = (count: number): GetAllBuildsApiArg | SkipToken => {
  const buildTypeId = useBuildTypeId()
  const branch = useBranch()
  return buildTypeId != null
    ? {
        locator: [
          `defaultFilter:false,buildType:(id:${buildTypeId}),count:${count + 1}`,
          getBranchLocator(branch),
        ]
          .filter(Boolean)
          .join(','),
        fields:
          'count,build(' +
          `${commonBuildFields},personal,user(id),detachedFromAgent,branchName,defaultBranch` +
          ',number,queuePosition,startDate,triggered(date),statusText,waitReason,startEstimate' +
          `,related(builds(\$locator(${getBuildChainLocator('id:$context.build.id')})` +
          `,build(${commonBuildFields},buildType(id))))` +
          ')',
      }
    : skipToken
}
